const queryKeys = {
	getEmissionTargets: 'getEmissionTargets',
	getEmployeeOnboardOrganizationsEntities: 'employeeOnboardOrganizationEntities',
	getOrganizationTokenData: 'employeeOnboardOrganizationEntities',
	usersOrganizations: 'usersOrganizations',
	upcomingTrips: 'upcomingTrips',
	suggestedRestaurants: 'suggestedRestaurants',
	suggestedPlacesToRelax: 'suggestedPlacesToRelax',
	transportationToHotel: 'transportationToHotel',
	showRatingModal: 'showRatingModal',
	deleteEmissionTargetData: 'deleteEmissionTargetData',
	searchTerm: 'searchTerm',
	climateProNotificationSettings: 'climateProNotificationSettings',
	certificates: 'certificates',
	factorFramework: 'factorFramework',
	factorFrameworkOptions: 'factorFrameworkOptions',
	organizationEntities: 'organizationEntities',
	responsibleUsers: 'responsibleUsers',
	allocationTables: 'allocationTables',
	metrics: 'metrics',
	entitiesFilter: 'entitiesFilter',
	co2Segments: 'co2Segments',
	co2Analytics: 'co2Analytics',
	travelLogHistory: 'travelLogHistory',
	allItineraries: 'allItineraries',
	getMyClimateMetrics: 'getMyClimateMetrics',
	getMyClimateCarbonFootprint: 'getMyClimateCarbonFootprint',
	getOrganizationLogin: 'getOrganizationLogin',
	dataComplianceSummary: 'dataComplianceSummary',
	dataCompliancePastTrips: 'dataCompliancePastTrips',
	dataComplianceSourceModelItineraries: 'dataComplianceSourceModelItineraries',
	dataComplianceTravelerItineraries: 'dataComplianceTravelerItineraries',
	dataComplianceNumOfTrips: 'dataComplianceNumOfTrips',
	dataUncompliantItineraries: 'dataUncompliantItineraries',
	dataComplianceSelectableItineraries: 'dataComplianceSelectableItineraries',
	dataComplianceSettings: 'dataComplianceSettings',
};

export default queryKeys;
